import React from "react";
import { typography, surfaces, borders, textColors, interactive } from "../../../design-system/tokens";

export const PositionField = ({ value, onChange, label, help }) => {
  const positionChoices = [
    { value: "top-left", label: "Top Left", icon: "↖" },
    { value: "top-center", label: "Top Center", icon: "↑" },
    { value: "top-right", label: "Top Right", icon: "↗" },
    { value: "middle-left", label: "Middle Left", icon: "←" },
    { value: "middle-center", label: "Middle Center", icon: "●" },
    { value: "middle-right", label: "Middle Right", icon: "→" },
    { value: "bottom-left", label: "Bottom Left", icon: "↙" },
    { value: "bottom-center", label: "Bottom Center", icon: "↓" },
    { value: "bottom-right", label: "Bottom Right", icon: "↘" },
  ];

  return (
    <div className="field-wrapper">
      {label && <label className={`block mb-2 ${typography.label} ${textColors.secondary}`}>{label}</label>}
      <div
        className={`inline-grid gap-1.5 p-2 border rounded-xl ${surfaces.secondary} ${borders.default}`}
        style={{ gridTemplateColumns: "repeat(3, 1fr)" }}
      >
        {positionChoices.map((choice) => {
          const selected = value === choice.value;
          return (
            <button
              key={choice.value}
              type="button"
              onClick={() => onChange(choice.value)}
              className={`w-10 h-10 text-lg rounded-lg border transition-all flex items-center justify-center
                ${selected
                  ? `${interactive.selectedBg} text-white ${interactive.selectedBorder} shadow-sm`
                  : `${surfaces.tertiary} ${textColors.primary} ${borders.default} hover:bg-gray-100 dark:hover:bg-dark-700`
                }`}
              title={choice.label}
              aria-label={choice.label}
              aria-pressed={selected}
            >
              {choice.icon}
            </button>
          );
        })}
      </div>
      {help && <div className={`mt-2 ${typography.caption} ${textColors.tertiary}`}>{help}</div>}
    </div>
  );
};
